/**
 * Custom Param
 */
(() => {
  const mobileHeader = document.querySelector('.header-mobile');
  if (mobileHeader) {
    // Clone account to header
    const account = mobileHeader.querySelector('.dropdown-extras-btn.userpanel');
    if (account) {
      const accountClone = account.cloneNode(true);
      accountClone.classList.add('header-account');
      mobileHeader.append(accountClone);
    }

    // Move VAT to header
    const vat = mobileHeader.querySelector('.dropdown-extras-btn.toggle-vat-incl-wrapper');
    if (vat) {
      vat.classList.add('header-vat');
      mobileHeader.append(vat);
    }

    // Move Search to header
    const search = document.querySelector('.issearchpanel section.search');
    if (search) {
      search.classList.add('header-searchbar');
      mobileHeader.append(search);
    }

    // Clone logo to menu
    const logo = mobileHeader.querySelector('.header-logo .logo');
    const menu = mobileHeader.querySelector('.header-menu .dropdown-extras');
    if (logo && menu) {
      const logoClone = logo.cloneNode(true);
      logoClone.classList.add('menu-logo');
      menu.prepend(logoClone);
    }
  }
})();
